// src/hooks/hotelRatings/useForceDeleteAllHotelRatings.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllHotelRatings as forceDeleteAllHotelRatingsAPI } from "../../api/apiHotelRatings";
import parseError from "../../utils/parseError";

const useForceDeleteAllHotelRatings = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAll, isPending: isForceDeleteAll } = useMutation({
        mutationFn: forceDeleteAllHotelRatingsAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected hotel ratings permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelRatings"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete selected hotel ratings");
        },
    });

    return { forceDeleteAllHotelRatings: forceDeleteAll, isForceDeleteAll };
};

export default useForceDeleteAllHotelRatings;
